import api from "./api";

const BASE = "api/v1/novatra/materials";

async function listMaterials(params = {}) {
  const res = await api.get(BASE, { params });
  const data = res.data?.data ?? res.data;
  // The materials endpoint currently returns a plain array, while newer
  // responses may return { items, pagination }.
  return Array.isArray(data)
    ? { items: data.map(normalizeMaterial), pagination: null }
    : { ...data, items: (data?.items || []).map(normalizeMaterial) };
}

function normalizeMaterial(material = {}) {
  const lookupId = (value) =>
    value && typeof value === "object" ? value._id || value.id : value || "";
  return {
    ...material,
    categoryName: material.category?.name || material.categoryId?.name || material.categoryName,
    uomName: material.uom?.name || material.uomId?.name || material.uomName,
    taxCategoryName: material.taxCategory?.name || material.taxCategoryId?.name || material.taxCategoryName,
    categoryId: lookupId(material.categoryId),
    brandId: lookupId(material.brandId),
    uomId: lookupId(material.uomId),
    taxCategoryId: lookupId(material.taxCategoryId),
  };
}

async function getMaterial(id) {
  const res = await api.get(`${BASE}/${id}`);
  return normalizeMaterial(res.data?.data ?? res.data);
}

async function createMaterial(payload) {
  const res = await api.post(BASE, payload);
  return res.data.data;
}

async function updateMaterial(id, payload) {
  const res = await api.put(`${BASE}/${id}`, payload);
  return res.data.data;
}

async function deleteMaterial(id) {
  const res = await api.delete(`${BASE}/${id}`);
  return res.data.data;
}

export default {
  listMaterials,
  getMaterial,
  getMaterialById: getMaterial,
  createMaterial,
  updateMaterial,
  deleteMaterial,
};
